import React, { useState } from 'react';
import { Pagination } from './Pagination';

export function PaginationExample(): JSX.Element {
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);

  return (
    <div className="styleguide__pagination">
      <Pagination totalCount={421} page={page} perPage={perPage} setPage={setPage} setPerPage={setPerPage} />
    </div>
  );
}
